export const featurecolors = {
  Admin: '#8b28a3',
  CastMeasurements: '#8b28a3',
  CreateCharacter: '#8b28a3',
  CreateCast: '#8b28a3',
  Unknown: '#F09219',
};
